import instance from '@apis/instance';
import { GetVersionParams, VersionResponse } from '@models/version';

class VersionApi {
    static getVersion(params: GetVersionParams): Promise<VersionResponse> {
        return instance.get('/app-versions/check', { params });
    }
}

export default VersionApi;
